<template>
  <div>
    <Head :title="form.part_number" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-blue-400 hover:text-blue-600" href="/grates">Grates</Link>
      <span class="text-blue-400 font-medium">/</span>
      {{ form.part_number }}
    </h1>
    <trashed-message v-if="grate.deleted_at" class="mb-6" @restore="restore"> This grate has been deleted. </trashed-message>
    <div class="max-w-3xl bg-white  shadow overflow-hidden">
      <form @submit.prevent="update">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <select-input v-model="form.width" :error="form.errors.width" class="pb-8 pr-6 w-full lg:w-1/2" label="Width">
            <option v-for="w in widths" :key="w.id" :value="w.id"> {{ w.label }}</option>
          </select-input>
          <select-input v-model="form.class" :error="form.errors.class" class="pb-8 pr-6 w-full lg:w-1/2" label="Load Class">
            <option v-for="c in classes" :key="c.id" :value="c.id"> {{ c.name }}</option>
          </select-input>
          <select-input v-model="form.material" :error="form.errors.material" class="pb-8 pr-6 w-full lg:w-1/2" label="Material">
            <option v-for="m in materials" :key="m.id" :value="m.id"> {{ m.name }}</option>
          </select-input>
          <select-input v-model="form.design" :error="form.errors.design" class="pb-8 pr-6 w-full lg:w-1/2" label="Design">
            <option v-for="d in designs" :key="d.id" :value="d.id"> {{ d.name }}</option>
          </select-input>
          <text-input v-model="form.part_number" :error="form.errors.part_number" class="pb-8 pr-6 w-full lg:w-1/2" label="Part number" />
          <!-- <text-input v-model="form.price" :error="form.errors.price" class="pb-8 pr-6 w-full lg:w-1/2" label="Price" /> -->
          <text-input v-model="form.length_im" :error="form.errors.length_im" class="pb-8 pr-6 w-full lg:w-1/2" label="Length Imperial" />
          <text-input v-model="form.length" :error="form.errors.length" class="pb-8 pr-6 w-full lg:w-1/2" label="Length" />
          <textarea-input v-model="form.description" :error="form.errors.description" class="pb-8 pr-6 w-full" label="Description" />
          <file-input v-model="form.image" :error="form.errors.image" class="pb-8 pr-6 w-full lg:w-1/2" type="file" accept="image/*" label="Image" />
        </div>
        <!-- Price Lists -->
        <div class="mt-6 rounded shadow overflow-x-auto">
          <table class="w-full whitespace-nowrap">
            <tr class="text-left font-bold">
              <th class="pb-4 pt-6 px-6">Price Lists</th>
              <th class="pb-4 pt-6 px-6">Alias</th>
              <th class="pb-4 pt-6 px-6">Price</th>
            </tr>
            <tr v-for="(pricelist, i) in form.pricelists" :key="pricelist.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
              <td class="px-6 py-2 focus:text-blue-500">
                {{ pricelist.name }}
                <icon v-if="pricelist.deleted_at" name="trash" class="flex-shrink-0 ml-2 w-3 h-3 fill-gray-400" />
              </td>
              <td class="px-6 py-2 focus:text-blue-500">
                <text-input v-model="pricelist.alias" :error="form.errors[`pricelists.${i}.alias`]" class="w-full" />
              </td>
              <td class="px-6 py-2 focus:text-blue-500">
                <text-input v-model="pricelist.price" :error="form.errors[`pricelists.${i}.price`]" class="w-full" label="" type="number" min="0" step="0.01" />
              </td>
            </tr>
            <tr v-if="pricelists.length === 0">
              <td class="px-6 py-4 border-t" colspan="4">No price lists found.</td>
            </tr>
          </table>
        </div>
        <div class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
          <button v-if="! grate.deleted_at" class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">Delete Grate</button>
          <loading-button :loading="form.processing" class="btn-blue ml-auto" type="submit">Update Grate</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/vue3'
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import TextareaInput from '@/Shared/TextareaInput'
import LoadingButton from '@/Shared/LoadingButton'
import SelectInput from '@/Shared/SelectInput'
import FileInput from '@/Shared/FileInput'
import TrashedMessage from '@/Shared/TrashedMessage'

export default {
  components: {
    Head,
    Link,
    Icon,
    LoadingButton,
    TextInput,
    TextareaInput,
    SelectInput,
    FileInput,
    TrashedMessage,
  },
  layout: Layout,
  props: {
    widths   : Array,
    classes  : Array,
    materials: Array,
    designs  : Array,
    pricelists : Array,
    grate    : Object,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        _method   : 'put',
        width      : this.grate.width,
        class      : this.grate.class,
        material   : this.grate.material,
        design     : this.grate.design,
        part_number: this.grate.part_number,
        description: this.grate.description,
        length_im  : this.grate.length_im,
        length     : this.grate.length,
        image      : null,
        // price      : this.grate.price,
        pricelists       : this.pricelists,
      }),
    }
  },
  methods: {
    update() {
      this.form.post(`/grates/${this.grate.id}`, {
        onSuccess: () => this.form.reset('image'),
      })
    },
    destroy() {
      if (confirm('Are you sure you want to delete this grate?')) {
        this.$inertia.delete(`/grates/${this.grate.id}`)
      }
    },
    restore() {
      if (confirm('Are you sure you want to restore this grate?')) {
        this.$inertia.put(`/grates/${this.grate.id}/restore`)
      }
    },
  },
}
</script>
